import GLightbox from 'glightbox';

const selectors = {
  container: '.js-pageInfoLightbox',
};

export default class PageInfoLightbox {
  static initAll(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    GLightbox({
      selector: selectors.container,
    });
  }
}
